import { render, staticRenderFns } from "./HotelResultCard.vue?vue&type=template&id=67a3389f&scoped=true"
import script from "./HotelResultCard.vue?vue&type=script&lang=js"
export * from "./HotelResultCard.vue?vue&type=script&lang=js"
import style0 from "./HotelResultCard.vue?vue&type=style&index=0&id=67a3389f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a3389f",
  null
  
)

export default component.exports